<template>
<div>
  <div v-for="(v,i) in useMessage.业主列表" :key="i">
    <van-cell-group :title="'业主信息'+(i+1)">
    <van-field
      v-model="v.姓名"
      name="姓名"
      label="姓名"
    />
    <van-field name="sex" label="性别" required>
      <template #input>
        <van-radio-group v-model="v.sex" direction="horizontal">
          <van-radio name="1">男</van-radio>
          <van-radio name="0">女</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
  
      v-model="v.tel"
      type="tel"
      name="tel"
      required
      label="电话"
      placeholder="请填写电话"
      
    />
    
    
      </van-cell-group>
  </div>
  
</div>

</template>
<script>
import { area1 } from "@/utils/area";
export default {
  name: "userMessage",
  props: {
    useMessage: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      areaList: area1,
      showArea: false,
      showPopup: false,
      popubName:"",
      popubIndex: -1,
      questionnaire: [],
      popupList: [],
      rule_required: { trigger: "onBlur", required: true, message: "*" },
      //pattern: /^[1][3,4,5,7,8][0-9]{9}$/, //用户名正则校验
      rule_tel: {
        trigger: "onBlur",
        validator: (value) => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[35678]|18[0-9]|19[0-9]|199|14[57])[0-9]{8}$/.test(
            value
          );
        },
        message: "不是有效的手机号",
      },
    };
  },
  created() {
    //this.getQuestionnaire();
  },

  methods: {
      
    lockTel(){
      return this.useMessage._id != ''
    },
    ShowPopub(name){
          this.popubName=name
          if(name =='证件类型'){
              this.popupList=["11","222"]
              
          }
           if(name =='国籍'){
              this.popupList=["中国","美国"]
             
          }
          this.showPopup=true
      },
    onPopupConfirm(value) {
   
      this.useMessage[this.popubName] = value
      this.showPopup = false;
    },
    //选择城市
    onConfirm(values) {
      this.useMessage.pcc = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      console.log(this.value);
      this.showArea = false;
    },
  },
  components: {},
};
</script>